import { useMemo } from 'react';
import { useServicesChartsDataContext } from './useServicesChartsDataContext';

export const useTop10 = () => {
    const { chartData } = useServicesChartsDataContext();

    const series = useMemo(
        () =>
            chartData.ranking?.map((item) => {
                return item.services;
            }),
        [chartData.ranking]
    );

    return {
        values: series,
        subtitles:
            chartData.ranking?.map(
                (item) => item.description || `${item.type}`
            ) || []
    };
};
